export const commonTestIds = {
	viewerHeader: 'viewer-header',
	viewerDetails: 'viewer-details',
	rightsInfoBtn: 'rights-info-btn',
	enrichBtn: 'enrich-document-btn',
	requestNewVersionBtn: 'request-new-version-btn',
	documentFrame: 'document-frame',
	actionBarDropdown: 'action-bar-dropdown',
	annotationMenuDropdown: 'annotation-menu-dropdown',
	abstractValue: 'abstract-value'
};
